import {Component, OnInit, Injector, Input, forwardRef, ChangeDetectorRef, ViewChild, OnChanges, SimpleChanges} from '@angular/core';
import { InputGridModel } from '../input-grid.model';
import { NgControl, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { InputGridColumnsBuilderModel } from './input-grid-columns-builder.model';
import { CODE_WORKFLOW_COMPONENT, TYPE_DATASOURCE, Model_WorkflowComponent } from 'src/app/app.models';
import { MatDialog } from '@angular/material/dialog';
import { InputGridColumnsBuilderDialogComponent } from '../input-grid-columns-builder-dialog/input-grid-columns-builder-dialog.component';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { InputGridFormComponent } from '../input-grid-form/input-grid-form.component';
import { COMPONENT_MODE } from '../../workflow-components.models';

@Component({
    selector: 'abw-input-grid-columns-builder',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => InputGridColumnsBuilderComponent),
        multi: true
      }
    ],
    templateUrl: './input-grid-columns-builder.component.html',
    styleUrls: ['./input-grid-columns-builder.component.scss']
})
export class InputGridColumnsBuilderComponent implements OnInit, OnChanges, ControlValueAccessor {
	@Input() model: InputGridColumnsBuilderModel;
    @Input() value: any[] = [];
    @ViewChild('gridForm') gridFormComponent: InputGridFormComponent;
	ngControl: NgControl;
    allowedCodeComponents = [
        CODE_WORKFLOW_COMPONENT.TEXTBOX,
        CODE_WORKFLOW_COMPONENT.NUMERIC_TEXTBOX,
        CODE_WORKFLOW_COMPONENT.TEXTAREA,
        CODE_WORKFLOW_COMPONENT.DATEPICKER,
        CODE_WORKFLOW_COMPONENT.DROPDOWN,
        CODE_WORKFLOW_COMPONENT.TOGGLE,
        CODE_WORKFLOW_COMPONENT.SCAN_QRCODE,
        CODE_WORKFLOW_COMPONENT.SCAN_DOCUMENT,
        CODE_WORKFLOW_COMPONENT.UPLOAD_FILE,
        CODE_WORKFLOW_COMPONENT.CAMERA,
        CODE_WORKFLOW_COMPONENT.FAMOCO_SCAN_LASER,
        CODE_WORKFLOW_COMPONENT.INPUT_GRID,
    ];
    allowedComponents: Model_WorkflowComponent[] = [];
    gridModelProperties = {
        ID: 'GRID_COLUMNS', 
        CODE: CODE_WORKFLOW_COMPONENT.INPUT_GRID, 
        LABEL: 'Colonnes',
        GRID_COLUMNS: [
            { ID: 'CODE', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Type', IS_REQUIRED: true, DEFAULT_VALUE: CODE_WORKFLOW_COMPONENT.TEXTBOX, CUSTOM_VALIDATORS: [{ VALIDATOR_NAME: 'no_whitespace' }], 
                UIC_PARAMS: {
                    DATASOURCE: {
                        DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
                        DATASOURCE_DATAS: [],
                        DATASOURCE_FILTERED_DATAS: [],
                        DATASOURCE_VALUE_FIELD: 'ID',
                        DATASOURCE_DISPLAY_FIELD: 'TEXT'
                    }
                }
            },
            { ID: 'ID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Identifiant', IS_REQUIRED: true },
            { ID: 'LABEL', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Libellé', IS_REQUIRED: true },
        ],
        IS_READONLY: false,
        IS_ROWS_EDITABLE: false,
        IS_ROWS_DELETABLE: false,
    };
    gridModel = InputGridModel.initModel(this.gridModelProperties, { COMPONENTS_MODE: COMPONENT_MODE.EXECUTION });
    
    constructor(
		private inj: Injector,
        private dialog: MatDialog,
        private _workflowComponentsService: WorkflowComponentsService,
        private _cdf: ChangeDetectorRef
    ) {
    }

    async ngOnInit() {
        const components = await this._workflowComponentsService.doGetBaseWorkflowComponents().toPromise();
        this.allowedComponents = components.filter(c => this.allowedCodeComponents.lastIndexOf(c.CODE) > -1);
        if (this.gridModelProperties.GRID_COLUMNS[0].UIC_PARAMS !== undefined) {
            this.gridModelProperties.GRID_COLUMNS[0].UIC_PARAMS.DATASOURCE.DATASOURCE_DATAS = this.allowedComponents.map(c => ({ ID: c.CODE, TEXT: c.LABEL }));
            this.gridModelProperties.GRID_COLUMNS[0].UIC_PARAMS.DATASOURCE.DATASOURCE_FILTERED_DATAS = this.allowedComponents.map(c => ({ ID: c.CODE, TEXT: c.LABEL }));
        }
        this.gridModel = InputGridModel.initModel(this.gridModelProperties, { COMPONENTS_MODE: COMPONENT_MODE.EXECUTION });
        this.gridModel.value = this.value;
        this._cdf.detectChanges();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!!changes.model && !!changes.model.currentValue) {
            this.gridModelProperties.IS_READONLY = this.model.readOnly;
            this.gridModelProperties.IS_ROWS_EDITABLE = this.model.isRowsEditable;
            this.gridModelProperties.IS_ROWS_DELETABLE = this.model.isRowsDeletable;
        }
    }

    propagateChange = (_: any) => {};
    registerOnChange(fn) { this.propagateChange = fn; }
    registerOnTouched() {}
    writeValue(value: any[]) {
        this.gridModel.value = value;
        this.value = value; 
    }

    onValueChanged(_gridColumnsProperty: any[]) {
        this.value = _gridColumnsProperty;
        this.propagateChange(this.value);
        this._cdf.detectChanges();
    }

    openDialog(_event: { index: number, data: any }): void {
        const gridColumns = this.gridFormComponent.getRowValues();
        const dialogRef = this.dialog.open(InputGridColumnsBuilderDialogComponent, {
            data: { 
                allowedComponents: this.allowedComponents, 
                selectedColumnIndex: _event.index, 
                selectedColumn: _event.data, 
                columns: this.model.additional.workflowComponents.filter(c => c.ID != this.model.id), 
                gridColumns: gridColumns.filter(c => c.ID != this.model.id), 
                variablesEnvironnement: !!this.model.additional.variablesEnvironnement ? this.model.additional.variablesEnvironnement : [], 
            },
            panelClass: 'custom-modal'
        });
    
        dialogRef.afterClosed().subscribe((result?: { columnIndex: number, column: any }) => {
            if (result === undefined) { return; }
            this.gridFormComponent.setRowValues(result.columnIndex, result.column);
        });
    }
}